  // fip square footage calculator for cartons

  // Index

  // Determine Flooring Type
  // 1. Looks at wrapper, grab data-flooring-type-

  // Get Price per carton
  // 1. Get price from class="price", store into casePrice
  // 2. Get numbers from casePrice, remove currency
  // 3. Convert price into float, store in valueArray

  // Get square footage
  // 1. Grab inputs from calculator
  // 2. Variable declarations
  // 3. Calculation function calculateCartons()

  // Watch DOM for inputs
  // 1. When length changes, call calculateCartons()
  // 2. When width changes, call calculateCartons()
  // 3. When sqft changes, do other math

  // First, determine type of calculator to use
const calculatorWrapper = document.querySelector('.flooring-calculator-wrapper');
const flooringType = calculatorWrapper ? calculatorWrapper.dataset.flooringType : null;

  // 0. Wrap this whole thing to make sure we even need to run a calculator
if (flooringType === 'carton' || flooringType === 'roll' ) {

  // get price from class="price"
  const casePriceHTML = document.querySelector(".price");
  // get inner value
  const casePrice = casePriceHTML.innerHTML;

  // extract out numbers from currency sign and USD
  const matches = casePrice.match(/\d+(\.\d+)?/g); // Matches integers and optional decimal parts

  // load price into valueArray[0]
  if (matches) {
    const valueArray = matches.map(numStr => parseFloat(numStr)); // Convert to floating-point numbers
  } else {
    console.log("No numbers found.");
  }

  // figure out room square footage
  // first grab footage inputs from DOM
  const roomLengthDOM = document.getElementById('room-length');
  const roomWidthDOM = document.getElementById('room-width');
  const roomSquareFootage = document.getElementById('room-square-footage');
  const quantityDOM = document.querySelector('input[name="quantity"][aria-label="Quantity"]');

  var cartonsNeededDOM = null;
  var rollLengthNeededDOM = null;
  if(flooringType === 'carton') {
    cartonsNeededDOM = document.getElementById('cartons-needed'); // For carton calculator
  } else if(flooringType === 'roll') {
    rollLengthNeededDOM = document.getElementById('roll-needed'); // For new roll calculator
  } else {
    // Do nothing.
  }

  // declare variables, set both to numbers
  var roomLength = 0;
  var roomWidth = 0;
  var squareFootage = 0;
  // var sqftPerCartonNumber = 0;
  var cartons = 0;
  var rollLength = 0;

  var sqftPerCarton = null;
  var widthPerRoll = null;
  if(flooringType === 'carton') {
    sqftPerCarton = Number(document.getElementById('sqft-per-carton').value); // For carton calculator
  } else if(flooringType === 'roll') {
    widthPerRoll = Number(document.getElementById('roll-width').value); // For new roll calculator
    if(isNaN(widthPerRoll) || widthPerRoll <= 0) {
      widthPerRoll = 12;
    }
  } else {
    // Do nothing.
  }

  // create the calculation function
  function calculateCartons() {
    // here we take the DOM elements, grab their values, convert to numbers
    roomLength = Number(roomLengthDOM.value);
    roomWidth = Number(roomWidthDOM.value);

    squareFootage = roomLength * roomWidth;
    roomSquareFootage.value = squareFootage;
    cartons = squareFootage / sqftPerCarton;
    cartonsNeededDOM.value = Math.ceil(cartons);

    quantityDOM.value = Math.ceil(cartons);
  }

  function calculateRoll() {
    // here we take the DOM elements, grab their values, convert to numbers
    roomLength = Number(roomLengthDOM.value);
    roomWidth = Number(roomWidthDOM.value);

    squareFootage = roomLength * roomWidth;
    roomSquareFootage.value = squareFootage;

    rollLength = squareFootage / widthPerRoll;
    rollLengthNeededDOM.value = Math.ceil(rollLength);

    quantityDOM.value = Math.ceil(rollLength);
  }

  // functions to calculate square footage
  // watches the DOM elements for input
  if(flooringType === 'carton') {
    roomLengthDOM.addEventListener('input', function(event) {
      calculateCartons();
    });
    roomWidthDOM.addEventListener('input', function(event) {
      calculateCartons();
    });
    roomSquareFootage.addEventListener('input', function(event) {
      cartons = roomSquareFootage.value / sqftPerCarton;
      cartonsNeededDOM.value = Math.ceil(cartons);
      quantityDOM.value = Math.ceil(cartons);
    });
  } else if(flooringType === 'roll') {
    roomLengthDOM.addEventListener('input', function(event) {
      calculateRoll();
    });
    roomWidthDOM.addEventListener('input', function(event) {
      calculateRoll();
    });
    roomSquareFootage.addEventListener('input', function(event) {
      rollLength = roomSquareFootage.value / widthPerRoll;
      rollLengthNeededDOM.value = Math.ceil(rollLength);
      quantityDOM.value = Math.ceil(rollLength);
    });
  } else {
    // Do nothing.
  }
}